<template>
    <div v-show="show">
        <TrustPilotReviewSliders />
        <slot></slot>
    </div>
</template>

<script>

import TrustPilotReviewSliders from './LeadCapture/TrustPilotReviewSliders.vue';

export default {
    components: {
        TrustPilotReviewSliders
    },

    data: () => ({
        currentStep: 1,
    }),

    created() {
        this.$event.$on('step:on-step', (step) => {
            this.currentStep = step
        });
    },

    computed: {
        /**
         * @returns {boolean}
         */
        show() {
            return this.currentStep == 1;
        }
    },
};
</script>
